/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./card-modular.vue?vue&type=template&id=4e19dd07&scoped=true&"
import script from "./card-modular.vue?vue&type=script&lang=ts&"
export * from "./card-modular.vue?vue&type=script&lang=ts&"
import style0 from "./card-modular.vue?vue&type=style&index=0&id=4e19dd07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19dd07",
  null
  
)

export default component.exports